<script>
import { provide, inject } from 'vue'

import { GenderMasterKey, HumanitiesOrScienceMasterKey, SchoolDepartmentMasterKey } from './injectionKey'

/**
 * @import { InjectionKey } from 'vue'
 * @import { Master, MasterForJs } from from './injectionKey.js'
 *
 * @type {{[k:string]: InjectionKey<Master>}}
 */
const masterInjectKeys = {
  gender_master: GenderMasterKey,
  humanities_or_science_master: HumanitiesOrScienceMasterKey,
  school_department_master: SchoolDepartmentMasterKey,
}

/**
 * @typedef {Record<keyof typeof masterInjectKeys[string], Record<number, string>>} MasterList
 */

export const provideMasters = () => {
  const v = /** @type {HTMLInputElement|null} */ (document.getElementById('masters'))?.value ?? 'null'
  const masters = /** @type {MasterList|null} */ JSON.parse(v)
  if (masters) {
    for (const [masterName, masterData] of Object.entries(masters)) {
      provide(masterInjectKeys[masterName], masterData)
    }
  }
}

/**
 *
 * @param {string} masterName
 * @returns {Master|MasterForJs|undefined}
 */
export const getMaster = masterName => {
  const key = masterInjectKeys[masterName]
  return key ? inject(key) : undefined
}

export const getAllMasters = () => {
  return Object.entries(masterInjectKeys).reduce((acc, [masterNameKey, injectionKey]) => {
    acc[/** @type {keyof typeof masterInjectKeys} */ (masterNameKey)] = inject(injectionKey)

    return acc
  }, /** @type {Record<keyof typeof masterInjectKeys,Master | undefined>} */ ({}))
}
</script>
